import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const ArrowLeftRight = ({ width = 14, height = 14 }: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 14 14"
  >
    <path
      d="M9.86364 7.08956L12.25 4.41978M12.25 4.41978L9.86364 1.75M12.25 4.41978L1.75 4.41978M4.13636 7.08956L1.75 9.75934M1.75 9.75934L4.13636 12.4291M1.75 9.75934L12.25 9.75934"
      stroke="#52575C"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
